import { render, staticRenderFns } from "./addDialForm.vue?vue&type=template&id=4db58e26&scoped=true"
import script from "./addDialForm.vue?vue&type=script&lang=js"
export * from "./addDialForm.vue?vue&type=script&lang=js"
import style0 from "./addDialForm.vue?vue&type=style&index=0&id=4db58e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db58e26",
  null
  
)

export default component.exports